import { BaseType } from '../base/base-type';
import { AnnuityGuaranteePeriodTypeId } from '../annuities/enum/annuity-guarantee-period-type';

export class AnnuityGuaranteePeriodType extends BaseType {
  public declare id: AnnuityGuaranteePeriodTypeId;
}
